import { ResultsFeedback as ResultsFeedbackPresenter } from './presenter';
import { connect, getActiveQuiz, setResultsFeedback, setResultsFeedbackEnabled } from '@instructure/quiz-core';
export function mapStateToProps(state) {
  var activeQuiz = getActiveQuiz(state);
  return {
    resultsFeedback: activeQuiz.getWorkingInstance().resultsFeedback,
    resultsFeedbackEnabled: activeQuiz.getWorkingInstance().resultsFeedbackEnabled,
    activeQuizId: activeQuiz.id
  };
}
export var ResultsFeedback = connect(mapStateToProps, {
  setResultsFeedback: setResultsFeedback,
  setResultsFeedbackEnabled: setResultsFeedbackEnabled
})(ResultsFeedbackPresenter);
export default ResultsFeedback;